(function (angular) {
	'use strict';

	var futureEarningsChartObject = {
		template: '<div id="future-earnings-chart"></div>',
		bindings: {
			chartName: '@',
			principal: '<',
			interest: '<',
			frequency: '<?',
			amount: '<?'
		},
		controller: [
			'$scope',
			'$window',
			'BREAKPOINTS',
			'futureEarningsFactory',
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			FutureEarningsChartFunction
		],
		controllerAs: 'futureEarnings'
	};

	angular
		.module('futureEarningsChartModule')
		.component('futureEarningsChart', futureEarningsChartObject);
	
	function FutureEarningsChartFunction(
		$scope,
		$window,
		BREAKPOINTS,
		futureEarningsFactory,
		Highcharts,
		HIGHCHARTS_OPTIONS
	) {	
		var futureEarnings = this;
		var chart;
		var chartLineColor = "hsl(210,10%,90%)";
		var chartLabelColor = "hsl(210,5%,55%)";
		var updatedChartDataMethod;
		var baselineChartDataMethod;
		var baselineChartData;
		var updatedChartData;
		var maxYValue;

		futureEarnings.$onInit = function() {
			updatedChartDataMethod = futureEarnings.chartName === 'Reinvestment' ? futureEarningsFactory.getReinvestmentDataWithCompoundingInterest : futureEarningsFactory.getDataWithAutoInvest;
			baselineChartDataMethod = futureEarnings.chartName === 'Reinvestment' ? futureEarningsFactory.getDataWithSimpleInterest : futureEarningsFactory.getReinvestmentDataWithCompoundingInterest;

			Highcharts.setOptions(HIGHCHARTS_OPTIONS());

			setChartData();
			initChart();
		};
		
		function setChartData(){
			baselineChartData = baselineChartDataMethod(futureEarnings.principal, futureEarnings.interest, 40);
			updatedChartData = updatedChartDataMethod(futureEarnings.principal, futureEarnings.interest, 40, futureEarnings.frequency, futureEarnings.amount);

			var lastPrincipalValueBaseline = baselineChartData[baselineChartData.length - 1].y;
			var lastPrincipalValueUpdated = updatedChartData[updatedChartData.length - 1].y;

			maxYValue = Math.max(lastPrincipalValueBaseline, lastPrincipalValueUpdated);
		}
		
		function getChartSeries() {
			return [{
				name: 'With ' + futureEarnings.chartName,
				type: 'line',
				color: '#F47735',
				data: updatedChartData,
				shadow: {
					color: '#F47735',
					offsetX: 3,
					offsetY: 3,
					opacity: 0.03,
					width: 9
				}
			},{
				name: 'Without ' + futureEarnings.chartName,
				type: 'line',
				color: '#878C92',
				data: baselineChartData,
				shadow: {
					color: '#878C92',
					offsetX: 3,
					offsetY: 3,
					opacity: 0.03,
					width: 9
				}
			}];
		}

		function initChart(){
			var chartSeries = getChartSeries();

			chart = new Highcharts.Chart({
				chart: {
					renderTo: 'future-earnings-chart',
					spacing: [0, 0, 0, 0]
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							color: 'black',
							useHTML: true,
							crop: $window.innerWidth < BREAKPOINTS.MD_START,
							overflow: $window.innerWidth >= BREAKPOINTS.MD_START ? 'none' : 'justify',
							style: {
								fontSize: '24px',
								borderWidth: 0,
								textShadow: false
							},
							formatter: function() {
								if(this.point.index === this.series.points.length - 1) {
									var amount = "<div>" + accounting.formatMoney(this.y, "$", 0) + "</div>";
									var subtitle = "<div class='zeta font-weight-normal'>" + this.series.name + "</div>";
									var label = "<div class='text-align-center'>" + amount + subtitle + "</div>";
									return label;
								}
							},
							y: -7
						},
						animation: {
							duration: 500
						},
						marker: {
							enabled: false
						},
						states: {
							hover: {
								enabled: false
							}
						},
						lineWidth: 3
					}
				},
				series: chartSeries,
				xAxis: {
					type: 'datetime',
					allowDecimals: false
				},
				yAxis: {
					endOnTick: false,
					gridLineColor: chartLineColor,
					labels: {
						formatter: function() {
							return '$' + Highcharts.numberFormat(this.value, 0);
						},
						style: {
							color: chartLabelColor
						}
					},
					min: futureEarnings.principal,
					max: parseInt(maxYValue * 1.25),
					startOnTick: false
				}
			});
		}

		$scope.$on('futureEarningsChart:update', function(evt, amount, frequency) {
			futureEarnings.amount = amount;
			futureEarnings.frequency = frequency;

			setChartData();
			
			var newData = getChartSeries();
			
			chart.update({
				yAxis: {
					max: parseInt(maxYValue * 1.25)
				}
			});

			while (chart.series.length > 0) {
				chart.series[0].remove(true);
			}

			chart.addSeries(newData[0]);
			chart.addSeries(newData[1]);
		});
	}
})(window.angular);